import { Button } from "@/view/components/ui/button";
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter } from "@/view/components/ui/alert-dialog";
import { ExternalAlert } from "@/app/services/externalConfigService/getProductsConfig";

interface AlertModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  alert?: ExternalAlert | undefined
}

export default function AlertModal({ isOpen, onOpenChange, alert}: AlertModalProps) {
  if (!alert?.active) return null

  const { title, subtitle, cta, image } = alert

  const handleCtaClick = () => {
    onOpenChange(false)
  }
  
  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent className="sm:max-w-sm">
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          {image && (
            <div className=" rounded-lg overflow-hidden">
              <img src={image} alt={title} className="w-full h-full object-cover" />
            </div>
          )}
          <AlertDialogDescription>{subtitle}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button className="text-white" onClick={handleCtaClick}>{cta}</Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}